import React, { createRef } from 'react';
import PropTypes from 'prop-types';
import Uppy from '@uppy/core';
import ImageEditorPlugin from '@uppy/image-editor';
import ImageEditorConfig from '../UppyUploader/ImageEditorConfig';

class ImageEditor extends React.Component {
  constructor(props) {
    super(props);
    this.container = createRef();
  }

  componentDidMount() {
    this.#installPlugin();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.uppy !== this.props.uppy) {
      this.#uninstallPlugin();
      this.#installPlugin();
    } else if (prevProps.currentFile !== this.props.currentFile) {
      this.plugin.selectFile(this.props.currentFile);
      this.plugin.cropper.reset();
    }
  }

  componentWillUnmount() {
    this.#uninstallPlugin();
  }

  #installPlugin() {
    const { uppy } = this.props;
    const config = {
      ...ImageEditorConfig(this.props),
      id: 'react:ImageEditor',
      target: this.container.current
    };

    uppy.use(ImageEditorPlugin, config);
    this.plugin = uppy.getPlugin(config.id);
    this.plugin.selectFile(this.props.currentFile);
  }

  #uninstallPlugin() {
    const { uppy } = this.props;
    uppy.removePlugin(this.plugin);
  }

  render() {
    const className = this.props.isVisible
      ? 'kj-uploader-ImageEditorPanel__container'
      : 'kj-uploader-ImageEditorPanel__container--hidden';
    return (
      <div ref={this.container} className={className} />
    );
  }
}

ImageEditor.propTypes = {
  uppy: PropTypes.instanceOf(Uppy).isRequired,
  currentFile: PropTypes.shape({}).isRequired,
  isVisible: PropTypes.bool
};

ImageEditor.defaultProps = {
  isVisible: true
};

export default ImageEditor;
